const PaymentMethods = {
  Manual: 1,
  Buypass: 2
};

Object.freeze(PaymentMethods);

export default PaymentMethods;